// src/utils/axiosConfig.js
import axios from "axios";
import { showToast } from "../CoreDataService";

/*
 * DO NOT re-add Origin / X-Origin / Domain headers here.
 *
 * This file used to force four headers onto every axios request and onto a
 * monkey-patched window.fetch:
 *
 *   Origin, origin, X-Origin, Domain  = "https://exchange-whitelabel-hc.paybito.com/"
 *
 * That broke every API call in production with a CORS error:
 *
 *   1. `Origin` is a forbidden header name. Browsers refuse to let JavaScript
 *      set it, so those lines never did anything in a browser — the browser
 *      already sends the real Origin automatically, and it is correct.
 *
 *   2. `X-Origin` and `Domain` are custom headers, and ANY custom header makes
 *      the browser send a preflight OPTIONS first. accounts.paybito.com replies
 *      with a fixed list:
 *
 *        Access-Control-Allow-Headers: Authorization, X-PINGOTHER, Origin,
 *          X-Requested-With, Content-Type, Accept, Content-Disposition
 *
 *      `x-origin` and `domain` are not in it, so the browser rejects the
 *      preflight and blocks the request. The server still answers 200 with the
 *      right Access-Control-Allow-Origin, which is why the backend team saw
 *      nothing wrong on their side — the rejection happens in the browser.
 *
 *   3. The value carried a trailing slash, which is not a valid serialized
 *      origin (scheme://host[:port]) and would never match an allowlist entry.
 *
 * If a server endpoint ever genuinely needs the caller's domain, send it as a
 * request parameter, or have Infra add the header name to
 * Access-Control-Allow-Headers first. Setting it client-side breaks everything
 * until they do.
 */

const setupAxiosInterceptors = () => {
  // Request interceptor
  axios.interceptors.request.use(
    (config) => {
      config.headers = config.headers || {};

      const token = localStorage.getItem("access_token");
      if (token && !config.headers["Authorization"]) {
        // config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        // Clear auth tokens
        // localStorage.setItem("access_token", "");

        showToast("error", "Session timedout. Please login again");
        // localStorage.removeItem('uuid');

        // Redirect to login page
        localStorage.clear();
        window.location.href = "/";
        window.location.reload();
      }

      return Promise.reject(error);
    }
  );

  // The global window.fetch monkey-patch that used to live here is gone.
  //
  // It applied the same four headers to EVERY fetch in the app — including
  // calls made by third-party libraries — so it broke those too, and it did it
  // invisibly from a file nobody would think to look in. The browser sends the
  // correct Origin on its own; nothing needs to be added.
};

export default setupAxiosInterceptors;
